import 'twin.macro';
import 'styled-components/macro';
import { FC } from 'react';

import { Rating } from 'toy/atoms/rating/Rating';

interface ReviewCardProps {
  author: string;
  rating: number;
  text: string;
}

export const ReviewCard: FC<ReviewCardProps> = ({ author, rating, text }) => {
  return (
    <div tw="min-w-[445px] rounded-sm border-1 p-3 bg-white rounded-b-sm">
      <div tw="flex flex-col gap-3 gap-2">
        <div tw="flex justify-between items-center">
          <div tw="min-w-[260px]">
            <div tw="text-gray-50">Author, </div>
            <div>{author}</div>
          </div>

          <div>
            <div tw="text-gray-50">Rated</div>
            <Rating value={rating} disabled />
          </div>
        </div>

        <div>{text}</div>
      </div>
    </div>
  );
};
